export const HOME = {
  emergentLink: "home-emergent-link",
  // Header
  headerLogo: "header-logo",
  navServices: "nav-link-services",
  navSizes: "nav-link-sizes",
  navPricing: "nav-link-pricing",
  navFaq: "nav-link-faq",
  navContact: "nav-link-contact",
  ctaHeaderQuote: "header-cta-quote",
  ctaHeaderCall: "header-cta-call",
  // Hero
  heroHeading: "hero-heading",
  ctaHeroQuote: "hero-cta-quote",
  ctaHeroCall: "hero-cta-call",
  // Trust strip
  trustStrip: "trust-strip",
  // Steps
  stepsSection: "steps-section",
  // Sizes
  sizesSection: "sizes-section",
  // Pricing
  pricingSection: "pricing-section",
  pricingTabs: "pricing-tabs",
  // Service area
  serviceArea: "service-area-section",
  postalInput: "postal-input",
  postalSubmit: "postal-submit",
  postalResult: "postal-result",
  // Testimonials
  testimonialsSection: "testimonials-section",
  // FAQ
  faqSection: "faq-section",
  faqAccordion: "faq-accordion",
  // Lead form
  leadFormSection: "lead-form-section",
  leadName: "lead-name",
  leadPhone: "lead-phone",
  leadEmail: "lead-email",
  leadServiceType: "lead-service-type",
  leadBinSize: "lead-bin-size",
  leadAddress: "lead-address",
  leadDate: "lead-date",
  leadMessage: "lead-message",
  leadSubmit: "lead-submit",
  // Footer
  footer: "footer",
};
